import { render } from "./MyOrderDetails.vue?vue&type=template&id=62a4afaf"
import script from "./MyOrderDetails.vue?vue&type=script&lang=js"
export * from "./MyOrderDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__